import { Component, OnInit ,ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { CreateTipificacionComponent } from './create-tipificacion/create-tipificacion.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-tipificacion-recolector',
  templateUrl: './tipificacion-recolector.component.html',
  styleUrls: ['./tipificacion-recolector.component.scss']
})
export class TipificacionRecolectorComponent implements OnInit {
  private destroy$ = new Subject<void>();

	campanaColumns: string[] = ['NOMBRE', 'NIVEL' ,'ACCION'];
	dataSource = new MatTableDataSource<any>([]);
	private subscription: Subscription;
	private subscriptioncreate: Subscription;
	private subscriptionpais: Subscription;
	FILTER; resultsLength = 0;
	pageSize = 10;
	idpais;
	pageEvent: PageEvent;
	public actpage:number=0;

	

	@ViewChild('paginatortipologia') paginatortipologia: MatPaginator;

	constructor(
		private router: Router,
		private spinner: NgxSpinnerService,
		private gateway: GatewayService,
		public pageTitle: ComponentPageTitle,
		public _appservice: AppServiceService,
		public _busqueda: BusquedaService,
		public _create: CreateService,
		private dialog: MatDialog,
		public _filtroPais: FiltroPaisService,
		private localSave: LocalSaveService
	) { }

	ngOnInit() {
		const user = this.localSave.get('usuarioPGV');
		if (!user || user.idrol != 16) {
			this.router.navigate(['/home']);
		}
		
		this.idpais = this.localSave.get('pais');
		this.get(0);
		this.pageTitle.title = 'Tipificación Recolector';
		// this.loadUsuarios();
		this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.filtrartipologia(res.filtro);
			});
		this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.createTipologia();
			});
		this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.idpais = res.IDPAIS;
				this.get(0);
			}
		);
	}

	// ============== FILTRO ==============
	filter = '';
	public keyDownFunction(event) {
		if (event.keyCode == 13) {
			this.filtrogeneral();
		} else if (event.keyCode == 8 && this.filter == '') {
			this.filtrogeneral();
		}
	}
	public filtrogeneral() {
		this._busqueda.notificarBusqueda({ filtro: this.filter });
	}
	
	ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
		this.subscription.unsubscribe();
		this.subscriptioncreate.unsubscribe();
		this.subscriptionpais.unsubscribe();
	}

	cambioElementos(event?: PageEvent) {
		this.actpage = event.pageIndex; 
		this.get(event.pageIndex);
	}

	get(page) {
		this.spinner.show();
		if(page == 0){
			this.paginatortipologia.firstPage();
		}
		this.gateway.get('gettipologiare', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result) => {
			//console.log(result);
			let aux:any = result;
			this.dataSource = aux.rows;
			//this.resultsLength = result[1][0].TOTAL;
			this.gateway.get('gettipologiarecount', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result:any) => {
				//console.log(result.rows);
				this.resultsLength = result.rows[0].total;
				this.spinner.hide();
			});
		}
		).catch(function (e) {
		});
	}

	createTipologia() {
		const dialogRef = this.dialog.open(CreateTipificacionComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '40vh',
			data: { operacion: 'Crear', tipologia: { IDPAIS: this.idpais, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA } },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			this.get(this.actpage);
		});

	}

	filtrartipologia(data) {
		this.FILTER = data;
		this.get(0)
	}

	edit(element) {
		element.IDPAIS = this.idpais;
		const dialogRef = this.dialog.open(CreateTipificacionComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '40vh',
			data: { operacion: 'Editar', tipologia: element },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			if(result){
				this.get(this.actpage);
			}
		});
	}

	delete(element) {
		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { operacion: 'deletetipologiare', id: { IDTIPOLOGIA: element.idtipologia } }
		});

		dialogRef.afterClosed().subscribe(() => {
			this.get(0);
		});
	}

}
